import styled, { css } from 'react-emotion';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const newSetButton = css`
  background-color: ${colors.purple3};

  :hover {
    background-color: ${colors.purpleDark};
  }
`;

const pointer = css`
  pointer-events: none;
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translate(-50%, 80%);
  font-size: 32px;
  transform-origin: center bottom;
`;

export const GroupsContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export default pointer;
